/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import {
  Spinner,
  Tab,
  Tabs,
  Modal,
  Container,
} from "react-bootstrap";
import useApplicantKanboard from "./useApplicantKanboard";
import CandidateKanbanSearch from "./_components/CandidateKanbanSearch";
import CandidateKanbanBoard from "./_components/CandidateKanbanBoard";
import AssignedCandidates from "./_components/AssignedCandidates";
import MainLayout from "../../Common/MainLayout";
import SuggestedCandidates from "../../../_uiComponents/SuggestedCandidates";
import KanbanCandidatesTable from "../../../_uiComponents/KanbanCandidatesTable";
import KanbanJobCard from "../../../_uiComponents/KanbanJobCard";
export default (props) => {
  const {
    columns,
    loading,
    jobDetails,
    allInterviewKits,
    showAllInterviewKits,
    suggestedCandidates,
    suggestedCandidatesLoading,
    assignedInterviewKit,
    interviewKitsLoading,
    candidateKanbanSearch,
    showSearch,
    searchInputRef,
    candidateKanbanSearchLoading,
    assignedCandidates,
    assignedCandidatesLoading,
    toggleView,
    candidatesList,
    currentTab,
    stageLoading,
    listView,
    setLastElement,
    onViewApplicantProgressClick,
    onAssignInterviewKit,
    openInterviewKit,
    onDragEnd,
    onViewCandidateProfileClick,
    onSearch,
    onSearchInputChange,
    onJobShareClick,
    userType,
    onAssignInterviewEventClick,
    onScheduleInterviewClick,
    onCreateEventClick,
    onEventEditClick,
    scheduleInterviewModal,
    calendarEventLists,
    onOfferFilterChange,
    onAssessmentFilterChange,
    onInterviewFilterChange,
    onToggleViewClick,
    currentTabHandler,
    changeStageHandler
  } = useApplicantKanboard(props);


  const checkTags = (column, cardData) => {
    let tag = null;

    if (column.name === "ASSESSMENT") {
      if (
        Array.isArray(cardData?.assessment_kit_submitted_details) &&
        Array.isArray(cardData?.assessment_kit_details)
      ) {
        tag =
          cardData?.assessment_kit_submitted_details[0]?.interview_submitted ===
            true ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Submitted
            </span>
          ) : cardData?.assessment_kit_details[0]?.kit_accepted ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Accepted
            </span>
          ) : cardData?.assessment_kit_details[0]?.kit_declined ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Declined
            </span>
          ) : (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Pending
            </span>
          );
      }
    }

    if (column.name === "INTERVIEW") {
      if (Array.isArray(cardData?.interview_details)) {
        let interviewLength = cardData.interview_details.length;
        tag =
          interviewLength &&
            cardData.interview_details[0]?.room_videos.length === true ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Completed
            </span>
          ) : interviewLength ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Scheduled
            </span>
          ) : (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Pending
            </span>
          );
      }
    }

    if (column.name === "OFFER") {
      tag =
        cardData?.job_offer_details?.offer_accepted === true ? (
          <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
            Accepted
          </span>
        ) : cardData?.job_offer_details?.offer_rejected === true ? (
          <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
            Rejected
          </span>
        ) : (
          <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
            Pending
          </span>
        );
    }
    return tag;
  };

  return (
    <MainLayout pageName={"Kanban Board"}>
      <div className="kanban-board-main">
        <KanbanJobCard
          jobDetails={jobDetails}
          onAssignInterviewKit={onAssignInterviewKit}
          showAllInterviewKits={showAllInterviewKits}
          openInterviewKit={openInterviewKit}
          onScheduleInterviewClick={onScheduleInterviewClick}
          interviewKitsLoading={interviewKitsLoading}
          assignedInterviewKit={assignedInterviewKit}
          allInterviewKits={allInterviewKits}
          onJobShareClick={onJobShareClick}
          showSearch={showSearch}
          onSearchInputChange={onSearchInputChange}
          searchInputRef={searchInputRef}
          onSearch={onSearch}
          onToggleViewClick={onToggleViewClick}
          listView={listView}
          loading={loading}
          userType={userType}
        />
        {toggleView ?
          <Container>
            {showSearch ? (
              <CandidateKanbanSearch
                candidateKanbanSearch={candidateKanbanSearch}
                onViewApplicantProgressClick={onViewApplicantProgressClick}
                candidateKanbanSearchLoading={candidateKanbanSearchLoading}
              />
            ) : (
              <>
              <KanbanCandidatesTable
                  checkTags={checkTags}
                  suggestedCandidates={suggestedCandidates}
                  suggestedCandidatesLoading={suggestedCandidatesLoading}
                  onViewCandidateProfileClick={
                    onViewCandidateProfileClick
                  }
                  candidatesList={candidatesList}
                  currentTabHandler={currentTabHandler}
                  currentTab={currentTab}
                  changeStageHandler={changeStageHandler}
                  stageLoading={stageLoading}
                  userType={userType}
                />
              </>
            )
            }
          </Container>
          :
          <>
            <div className="kanban-board-wrapper">
              {loading ? (
                <div className="p-5 text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    className="text-center"
                  />
                </div>
              ) : (
                <div className="container  bg-white">
                  <div className="wrapper-right">

                    {showSearch ? (
                      <CandidateKanbanSearch
                        candidateKanbanSearch={candidateKanbanSearch}
                        onViewApplicantProgressClick={onViewApplicantProgressClick}
                        candidateKanbanSearchLoading={candidateKanbanSearchLoading}
                      />
                    ) : (
                      <Tabs defaultActiveKey="Kanboard" className="mt-3">
                        <Tab eventKey="Kanboard" title="Kanban Board">
                          <CandidateKanbanBoard
                            columns={columns}
                            onViewApplicantProgressClick={
                              onViewApplicantProgressClick
                            }
                            onDragEnd={onDragEnd}
                            checkTags={checkTags}
                            loading={loading}
                            onOfferFilterChange={onOfferFilterChange}
                            onAssessmentFilterChange={onAssessmentFilterChange}
                            onInterviewFilterChange={onInterviewFilterChange}
                          />

                          <div className="text-right mr-3 mb-2">
                            <button className="btn bg-grey-2 rounded-lg mt-2 py-1 border" onClick={onToggleViewClick}>Switch to List View</button>
                          </div>
                        </Tab>

                        <Tab
                          eventKey="SuggestedCandidates"
                          title="Suggested Candidates"
                        >
                          <SuggestedCandidates
                            suggestedCandidates={suggestedCandidates}
                            suggestedCandidatesLoading={suggestedCandidatesLoading}
                            onViewCandidateProfileClick={
                              onViewCandidateProfileClick
                            }
                          />

                          <div className="text-right mr-3 mb-2">
                            <button className="btn bg-grey-2 rounded-lg mt-2 py-1 border" onClick={onToggleViewClick}>Switch to List View</button>
                          </div>
                        </Tab>

                        {assignedCandidates?.length ? (
                          <Tab
                            eventKey="AssignedCandidates"
                            title={`Assigned Candidates (${assignedCandidates?.length})`}
                          >
                            <AssignedCandidates
                              assignedCandidates={assignedCandidates}
                              assignedCandidatesLoading={assignedCandidatesLoading}
                              onViewCandidateProfileClick={
                                onViewCandidateProfileClick
                              }
                            />
                          </Tab>
                        ) : null}
                      </Tabs>
                    )}
                  </div>
                </div>
              )}
            </div>
          </>
        }

        <Modal
          show={scheduleInterviewModal}
          centered
          size="xl"
          onHide={onScheduleInterviewClick}
          className="common-modal apply-job-modal schedule-interview-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Schedule Interview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white">
            <div className="event-list">
              {Array.isArray(calendarEventLists) &&
                calendarEventLists.length > 0 ? (
                <>
                  {Array.isArray(calendarEventLists) &&
                    calendarEventLists.map((item) => (
                      <>
                        <div
                          className="event-box  mb-3 d-flex align-items-start justify-content-between"
                          ref={setLastElement}
                          key={item?.id}
                        >
                          <div className="content">
                            <h3 className="font-weight-semi mb-2 text-primary cursor">
                              {item?.title}
                            </h3>
                            <p className="text-grey-4">
                              Estimated time: {item?.duration} mins | One to One
                              Interview
                            </p>
                          </div>
                          <div className="action">
                            <button
                              className="btn btn-light mr-3 mb-2 mb-md-0"
                              onClick={() => onEventEditClick(item?.id)}
                            >
                              Edit
                            </button>
                            {!item?.hash_id ? (
                              <button
                                className="btn btn-primary"
                                onClick={() => onEventEditClick(item?.id)}
                              >
                                Set Availability
                              </button>
                            ) : (
                              <button
                                className={`btn btn-primary`}
                                onClick={() =>
                                  onAssignInterviewEventClick(item?.id)
                                }
                              >
                                Assign
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    ))}
                </>
              ) : (
                <div className="d-flex justify-content-between align-items-center">
                  <p>
                    No events created. Please create an event in your calendar.
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={onCreateEventClick}
                  >
                    Create Event
                  </button>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </MainLayout>
  );
};
